export enum LEARNING_CORE {
    /**
     * @value An error occurred while loading the activity, please try again later
     * @description Error message displayed when a learning activity fails to load
     */
    ACTIVITY_LOADING_ERROR = 'LEARNING_CORE.ACTIVITY_LOADING_ERROR',
    /**
     * @value Correct
     * @description Label indicating that the answer given by the learner is correct
     */
    ANSWER_CORRECT = 'LEARNING_CORE.ANSWER_CORRECT',
    /**
     * @value Wrong
     * @description Label indicating that the answer given by the learner is wrong
     */
    ANSWER_WRONG = 'LEARNING_CORE.ANSWER_WRONG',
    /**
     * @value Available until: %DATE%
     */
    AVAILABLE_UNTIL_DATE = 'TRAINING_COURSE.AVAILABLE_UNTIL_DATE',
    /**
     * @value Back to training
     */
    BACK_TO_TRAINING = 'LEARNING_CORE.BACK_TO_TRAINING',
    /**
     * @value Close activity ?
     */
    CLOSE_ACTIVITY = 'LEARNING_CORE.CLOSE_ACTIVITY',
    /**
     * @value If you close this activity now, you will lose your progress.
     */
    CLOSE_ACTIVITY_DESCRIPTION = 'LEARNING_CORE.CLOSE_ACTIVITY_DIALOG_DESCRIPTION',
    /**
     * @value Close without saving
     */
    CLOSE_ACTIVITY_WITHOUT_SAVING = 'LEARNING_CORE.CLOSE_ACTIVITY_WITHOUT_SAVING',
    /**
     * @value Continue activity
     */
    CONTINUE_ACTIVITY = 'LEARNING_CORE.CONTINUE_ACTIVITY',
    /**
     * @value Correction not available for this activity
     * @description Message displayed when a learning activity has no correction to review
     */
    CORRECTION_NOT_AVAILABLE = 'LEARNING_CORE.CORRECTION_NOT_AVAILABLE',
    /**
     * @value GO!
     * @description Label displayed at the end of the countdown before a learning activity starts
     */
    COUNTDOWN_GO = 'LEARNING_CORE.COUNTDOWN_GO',
    /**
     * @value Send message
     * @description Button used to send a message to the opponent of a duel activity
     */
    DUEL_MESSAGE_SEND = 'LEARNING_CORE.DUEL_MESSAGE_SEND',
    /**
     * @value Send a message to %USER_NAME%
     * @description Placeholder of the field used to send a message to the opponent of a duel activity
     */
    DUEL_MESSAGE_TEXT = 'LEARNING_CORE.DUEL_MESSAGE_TEXT',
    /**
     * @value No opponent available
     * @description Message displayed when no opponent can be challenged in a duel activity
     */
    DUEL_NO_OPPONENT_AVAILABLE = 'LEARNING_CORE.DUEL_NO_OPPONENT_AVAILABLE',
    /**
     * @value Choose a random opponent
     * @description Button used to be matched with a random opponent in a duel activity
     */
    DUEL_OPPONENT_RANDOM = 'LEARNING_CORE.DUEL_OPPONENT_RANDOM',
    /**
     * @value Search opponent...
     * @description Placeholder of the opponent search field in a duel activity
     */
    DUEL_OPPONENT_SEARCH = 'LEARNING_CORE.DUEL_OPPONENT_SEARCH',
    /**
     * @value Choose an opponent
     * @description Title of the opponent selection screen of a duel activity
     */
    DUEL_OPPONENT_TITLE = 'LEARNING_CORE.DUEL_OPPONENT_TITLE',
    /**
     * @value Cancel the battle
     * @description Button cancelling the start of a duel activity
     */
    DUEL_POPUP_CANCEL = 'LEARNING_CORE.DUEL_POPUP_CANCEL',
    /**
     * @value Let the battle begin
     * @description Button confirming the start of a duel activity
     */
    DUEL_POPUP_CONFIRM = 'LEARNING_CORE.DUEL_POPUP_CONFIRM',
    /**
     * @value You are about to challenge %USER_NAME% to %ACTIVITY_NAME%. Are you ready?
     * @description Description of the confirmation popup displayed before starting a duel activity
     */
    DUEL_POPUP_TEXT = 'LEARNING_CORE.DUEL_POPUP_TEXT',
    /**
     * @value Ready to fight
     * @description Title of the confirmation popup displayed before starting a duel activity
     */
    DUEL_POPUP_TITLE = 'LEARNING_CORE.DUEL_POPUP_TITLE',
    /**
     * @value Due on: %DATE%
     */
    DUE_ON_DATE = 'TRAINING_COURSE.DUE_ON_DATE',
    /**
     * @value %ERRORS_COUNT% errors
     * @description Number of mistakes made by the learner in the correction of an activity
     */
    ERRORS_COUNT = 'LEARNING_CORE.ERRORS_COUNT',
    /**
     * @value Expected answer:
     * @description Label introducing the expected answer in the correction of an activity
     */
    EXPECTED_ANSWER = 'LEARNING_CORE.EXPECTED_ANSWER',
    /**
     * @value Expected answers:
     * @description Label introducing the expected answers in the correction of an activity
     */
    EXPECTED_ANSWERS = 'LEARNING_CORE.EXPECTED_ANSWERS',
    /**
     * @value Flip for more informations
     */
    FLIP_CARD_BUTTON = 'TRAINING_COURSE.FLIP_CARD_BUTTON',
    /**
     * @value Did you get it right ?
     */
    GET_IT_RIGHT = 'LEARNING_CORE.GET_IT_RIGHT',
    /**
     * @value Please fill all the boxes!
     * @description Message displayed when the learner submits an incomplete answer in a guess what activity
     */
    GUESS_WHAT_FILL_ALL_BOXES = 'LEARNING_CORE.GUESS_WHAT_FILL_ALL_BOXES',
    /**
     * @value Please type your answer here...
     * @description Placeholder of the answer field of a guess what activity
     */
    GUESS_WHAT_INPUT = 'LEARNING_CORE.GUESS_WHAT_INPUT',
    /**
     * @value Type your answer using your keyboard.
     * @description Message displayed when the answer typed in a guess what activity is invalid
     */
    GUESS_WHAT_INVALID_INPUT_MESSAGE = 'LEARNING_CORE.GUESS_WHAT_INVALID_INPUT_MESSAGE',
    /**
     * @value I don't know!
     * @description Button used by the learner to declare they do not know the answer in a guess what activity
     */
    GUESS_WHAT_I_DONT_KNOW = 'LEARNING_CORE.GUESS_WHAT_I_DONT_KNOW',
    /**
     * @value I know
     * @description Button used by the learner to declare they know the answer in a guess what activity
     */
    GUESS_WHAT_I_KNOW = 'LEARNING_CORE.GUESS_WHAT_I_KNOW',
    /**
     * @value You need to redo some activities in this chapter.
     */
    HELPER_FAILED_MODULE = 'TRAINING_COURSE.HELPER_FAILED_MODULE',
    /**
     * @value You need to do the previous module before beginning this one.
     */
    HELPER_LOCKED_MODULE = 'TRAINING_COURSE.HELPER_LOCKED_MODULE',
    /**
     * @value Learning path
     */
    LEARNING_PATH = 'LEARNING.LEARNING_PATH',
    /**
     * @value Learning paths
     */
    LEARNING_PATHS = 'LOOKER_LEARNING_LEARNING_PATHS',
    /**
     * @value Learning type
     */
    LEARNING_TYPE = 'LEARNING_CORE.LEARNING_TYPE',
    /**
     * @value For each answer, choose true or false.
     * @description Hint displayed at the top of a multi quiz activity
     */
    MULTI_QUIZ_HINT = 'LEARNING_CORE.MULTI_QUIZ_HINT',
    /**
     * @value My answer:
     * @description Label introducing the answer given by the learner in the correction of an activity
     */
    MY_ANSWER = 'LEARNING_CORE.MY_ANSWER',
    /**
     * @value My answers:
     * @description Label introducing the answers given by the learner in the correction of an activity
     */
    MY_ANSWERS = 'LEARNING_CORE.MY_ANSWERS',
    /**
     * @value Next Activity
     * @description Button displayed at the end of a learning activity to start the next one
     */
    NEXT_ACTIVITY = 'LEARNING_CORE.NEXT_ACTIVITY',
    /**
     * @value No errors
     * @description Label displayed in the correction of an activity when the learner made no mistake
     */
    NO_ERRORS = 'LEARNING_CORE.NO_ERRORS',
    /**
     * @value Overdue since: %DATE%
     */
    OVERDUE_SINCE_DATE = 'TRAINING_COURSE.OVERDUE_SINCE_DATE',
    /**
     * @value Retake
     * @description Button displayed at the end of a learning activity to play it again
     */
    RETAKE_ACTIVITY = 'LEARNING_CORE.RETAKE_ACTIVITY',
    /**
     * @value Review answers
     * @description Leanrning key for survey activity
     */
    REVIEW_ANSWERS = 'LEARNING_CORE.REVIEW_ANSWERS',
    /**
     * @value Scored activity
     */
    SCORED_ACTIVITY = 'TRAINING_COURSE.SCORED_ACTIVITY',
    /**
     * @value Score %NUMBER%%
     * @description Display score with percents
     */
    SCORE_NUMBER = 'LEARNING_CORE.SCORE_NUMBER',
    /**
     * @value See Correction
     * @description Button displayed at the end of a learning activity to review the correction
     */
    SEE_CORRECTION = 'LEARNING_CORE.SEE_CORRECTION',
    /**
     * @value Training course
     */
    TRAINING_COURSE = 'LEARNING.TRAINING_COURSE',
    /**
     * @value Wrong answer
     * @description Feedback displayed when the learner gives a wrong answer in a training game activity
     */
    TRAINING_GAME_ANSWER_FAIL = 'LEARNING_CORE.TRAINING_GAME_ANSWER_FAIL',
    /**
     * @value It's a correct answer but it can be better!
     * @description Feedback displayed when the learner gives a correct but improvable answer in a training game activity
     */
    TRAINING_GAME_ANSWER_NEUTRAL = 'LEARNING_CORE.TRAINING_GAME_ANSWER_NEUTRAL',
    /**
     * @value It is perfect!
     * @description Feedback displayed when the learner gives the best possible answer in a training game activity
     */
    TRAINING_GAME_ANSWER_SUCCESS = 'LEARNING_CORE.TRAINING_GAME_ANSWER_SUCCESS',
    /**
     * @value Your current progress
     * @description Label of the progress gauge of a training game activity
     */
    TRAINING_GAME_CURRENT_PROGRESS = 'LEARNING_CORE.TRAINING_GAME_CURRENT_PROGRESS',
    /**
     * @value Final question
     * @description Label displayed when only one question is left in a training game activity
     */
    TRAINING_GAME_LAST_QUESTION = 'LEARNING_CORE.TRAINING_GAME_LAST_QUESTION',
    /**
     * @value No more questions
     * @description Label displayed when no question is left in a training game activity
     */
    TRAINING_GAME_NO_QUESTION_LEFT = 'LEARNING_CORE.TRAINING_GAME_NO_QUESTION_LEFT',
    /**
     * @value %REMAINING_QUESTIONS% questions left
     * @description Number of questions left to answer in a training game activity
     */
    TRAINING_GAME_QUESTIONS_LEFT = 'LEARNING_CORE.TRAINING_GAME_QUESTIONS_LEFT',
    /**
     * @value An error occurred while loading the user, please try again later
     * @description Error message displayed when the current user cannot be loaded in a learning activity
     */
    USER_LOADING_ERROR = 'LEARNING_CORE.USER_LOADING_ERROR',
}
